import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import AvatarEditorModal from "../AvatarEditorModal";
import { AvatarWrapper, NameIntialAvatar } from "./styled";

const Avatar = ({ human, isEditable, size, ...rest }) => {
  const [editingAvatar, setEditingAvatar] = useState(false);
  const [imageLoadingErr, setImageLoadingErr] = useState(false);
  const onAvatarClick = useCallback(() => {
    setEditingAvatar(true);
  }, []);
  const onStopEditingAvatar = useCallback(() => {
    setEditingAvatar(false);
  }, []);
  const getNameInitials = useCallback((name) => {
    return name
      .match(/(\b\S)?/g)
      .join("")
      .match(/(^\S|\S$)?/g)
      .join("")
      .toUpperCase();
  }, []);

  return (
    <>
      <AvatarWrapper
        size={size}
        style={{ cursor: isEditable ? "pointer" : undefined }}
        onClick={isEditable ? onAvatarClick : undefined}
        {...rest}
      >
        {human.image && !imageLoadingErr ? (
          <img
            onError={() => setImageLoadingErr(true)}
            src={human.image}
            alt={human.name}
          />
        ) : (
          <NameIntialAvatar size={size}>
            {getNameInitials(human.name)}
          </NameIntialAvatar>
        )}
      </AvatarWrapper>
      {editingAvatar && (
        <AvatarEditorModal human={human} onClosed={onStopEditingAvatar} />
      )}
    </>
  );
};

Avatar.propTypes = {
  human: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
  isEditable: PropTypes.bool,
  size: PropTypes.string,
};

export default Avatar;
